import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { AppShell } from './AppShell';

export class Layout extends Component {
  //static displayName = Layout.name;

  render () {
    return (
      <AppShell>
        <Container fluid>
          {this.props.children}
        </Container>
      </AppShell>
    );
  }
}
